export const areasConfig = [
  {
    slug: "التجمع-الخامس",
    name_ar: "التجمع الخامس",
    landmarks: ["شارع التسعين", "كايرو فيستيفال سيتي", "ميدان فاطمة الشربتلي"],
    adjacent_areas: ["التجمع-الاول", "التجمع-الثالث", "القطامية"],
    local_context: "تغطية سريعة لشارع التسعين الشمالي والجنوبي، مع تواجد دائم بالقرب من كايرو فيستيفال سيتي ومحور المشير.",
    coverage_note: "متوسط وقت الوصول 15-20 دقيقة داخل التجمع الخامس."
  },
  {
    slug: "التجمع-الاول",
    name_ar: "التجمع الاول",
    landmarks: ["محور مصطفى كامل", "أكاديمية الشرطة", "بورتو كايرو مول"],
    adjacent_areas: ["التجمع-الخامس", "مدينة-نصر", "الرحاب"],
    local_context: "تمركز قريب من محور مصطفى كامل وأكاديمية الشرطة لتلبية نداءات الطوارئ وتفادي الزحام المروري.",
    coverage_note: "وصول سريع خلال 15 دقيقة لجميع مجاورات التجمع الأول."
  },
  {
    slug: "التجمع-الثالث",
    name_ar: "التجمع الثالث",
    landmarks: ["الجامعة الألمانية", "ميدان ارابيلا", "قطامية هايتس"],
    adjacent_areas: ["التجمع-الخامس", "القطامية", "زهراء-المعادي"],
    local_context: "خدمة فورية لطلاب الجامعة الألمانية وسكان منطقة ارابيلا، مع تغطية سريعة للطريق الدائري.",
    coverage_note: "نصلك أينما كنت في التجمع الثالث خلال 15 دقيقة كحد أقصى."
  },
  {
    slug: "مدينة-نصر",
    name_ar: "مدينة نصر",
    landmarks: ["مكرم عبيد", "عباس العقاد", "طريق النصر", "سيتي ستارز"],
    adjacent_areas: ["مصر-الجديدة", "التجمع-الاول", "العباسية"],
    local_context: "تعامل مرن مع زحام عباس العقاد ومكرم عبيد، وتغطية شاملة لطريق النصر ومحيط سيتي ستارز.",
    coverage_note: "وقت استجابة لا يتجاوز 20 دقيقة رغم الكثافة المرورية بمدينة نصر."
  },
  {
    slug: "القطامية",
    name_ar: "القطامية",
    landmarks: ["الطريق الدائري", "نادي الصيد", "مساكن القطامية"],
    adjacent_areas: ["التجمع-الثالث", "المعادي", "المقطم"],
    local_context: "تواجد مستمر بالقرب من الطريق الدائري ومداخل القطامية لضمان سرعة رفع السيارات المعطلة.",
    coverage_note: "وصول خلال 15-20 دقيقة لتغطية شاملة لأحياء القطامية والطريق الدائري."
  },
  {
    slug: "زهراء-المعادي",
    name_ar: "زهراء المعادي",
    landmarks: ["الشطر العاشر", "نادي وادي دجلة", "كارفور المعادي"],
    adjacent_areas: ["المعادي", "القطامية", "صقر-قريش"],
    local_context: "سرعة في الوصول لمحيط نادي وادي دجلة وكارفور المعادي، مع خبرة في تفادي التكدس وقت الذروة.",
    coverage_note: "نصلك في زهراء المعادي خلال 15 دقيقة فقط."
  },
  {
    slug: "المعادي",
    name_ar: "المعادي",
    landmarks: ["شارع 9", "الكورنيش", "ميدان السرايات", "دجلة"],
    adjacent_areas: ["زهراء-المعادي", "صقر-قريش", "المقطم"],
    local_context: "تغطية سريعة لشارع 9 والكورنيش، مع تعامل يومي مع زحمة طريق الأوتوستراد بالقرب من محطة المترو.",
    coverage_note: "متوسط وقت الوصول 15-20 دقيقة داخل المعادي."
  },
  {
    slug: "صقر-قريش",
    name_ar: "صقر قريش",
    landmarks: ["طريق الأوتوستراد", "مساكن صقر قريش", "المركز الأولمبي"],
    adjacent_areas: ["المعادي", "زهراء-المعادي"],
    local_context: "موقع تمركزنا الاستراتيجي قرب طريق الأوتوستراد يسهل وصولنا السريع لأي عطل في صقر قريش.",
    coverage_note: "وقت استجابة سريع يتراوح بين 10-15 دقيقة."
  },
  {
    slug: "مصر-الجديدة",
    name_ar: "مصر الجديدة",
    landmarks: ["ميدان الكوربة", "روكسي", "صلاح سالم", "نادي هليوبوليس"],
    adjacent_areas: ["مدينة-نصر", "النزهة", "شيراتون"],
    local_context: "نخدم شوارع مصر الجديدة العريقة بمرونة، متواجدون دوماً في الكوربة، روكسي، وبطول طريق صلاح سالم.",
    coverage_note: "وصول في أقل من 20 دقيقة لكافة أنحاء مصر الجديدة."
  },
  {
    slug: "السلام",
    name_ar: "السلام",
    landmarks: ["موقف العاشر", "الطريق الدائري", "طريق الإسماعيلية الزراعي"],
    adjacent_areas: ["العبور", "النزهة"],
    local_context: "تعامل سريع مع أعطال الطريق الدائري وموقف العاشر وحوادث طريق الإسماعيلية الزراعي.",
    coverage_note: "استجابة فورية لحالات الطوارئ في السلام وضواحيها خلال 20 دقيقة."
  },
  {
    slug: "شيراتون",
    name_ar: "شيراتون",
    landmarks: ["مساكن شيراتون", "شارع الصاعقة", "مطار القاهرة"],
    adjacent_areas: ["مصر-الجديدة", "النزهة", "طريق-السويس"],
    local_context: "تغطية مميزة لمحيط مطار القاهرة وشوارع مساكن شيراتون وتأمين الطرق المؤدية إليهما.",
    coverage_note: "نصلك في أي مكان في شيراتون خلال 15 دقيقة."
  },
  {
    slug: "النزهة",
    name_ar: "النزهة",
    landmarks: ["النزهة الجديدة", "جسر السويس", "سندباد"],
    adjacent_areas: ["مصر-الجديدة", "شيراتون", "السلام"],
    local_context: "نوفر إنقاذ سريع لرواد النزهة الجديدة وجسر السويس بعيداً عن الاختناقات المرورية.",
    coverage_note: "متوسط الوصول في النزهة لا يتعدى 15 دقيقة."
  },
  {
    slug: "العباسية",
    name_ar: "العباسية",
    landmarks: ["ميدان العباسية", "جامعة عين شمس", "طريق امتداد رمسيس"],
    adjacent_areas: ["مدينة-نصر", "مصر-الجديدة"],
    local_context: "خبرة واسعة في التعامل مع زحام ميدان العباسية وامتداد رمسيس لنضمن لك إنقاذاً سريعاً.",
    coverage_note: "وصول سريع رغم الكثافة المرورية في العباسية خلال 20 دقيقة."
  },
  {
    slug: "مدينتي",
    name_ar: "مدينتي",
    landmarks: ["بوابة 1 مدينتي", "منطقة السنترال بارك", "طريق السويس"],
    adjacent_areas: ["الشروق", "الرحاب", "طريق-السويس"],
    local_context: "أوناشنا متواجدة باستمرار قرب بوابات مدينتي لتغطية كافة المراحل السكنية والطريق الدائري الأوسطي.",
    coverage_note: "نصلك داخل مدينتي في غضون 15 دقيقة."
  },
  {
    slug: "الرحاب",
    name_ar: "الرحاب",
    landmarks: ["بوابات الرحاب", "السوق الشرقي", "محور السادات"],
    adjacent_areas: ["التجمع-الاول", "مدينتي"],
    local_context: "خدمة إنقاذ داخلية وخارجية لمدينة الرحاب ومحيط السوق الشرقي ومحور السادات.",
    coverage_note: "وقت استجابة قياسي لسكان الرحاب يتراوح بين 10-15 دقيقة."
  },
  {
    slug: "العبور",
    name_ar: "العبور",
    landmarks: ["سوق العبور", "طريق الإسماعيلية الصحراوي", "ميدان عرابي"],
    adjacent_areas: ["السلام", "الشروق"],
    local_context: "تغطية لمنطقة سوق العبور وميدان عرابي والخط السريع لطريق الإسماعيلية الصحراوي.",
    coverage_note: "نصلك في أي منطقة في العبور خلال 20 دقيقة."
  },
  {
    slug: "المقطم",
    name_ar: "المقطم",
    landmarks: ["شارع 9 المقطم", "الهضبة الوسطى", "ميدان النافورة"],
    adjacent_areas: ["المعادي", "القطامية"],
    local_context: "نتمركز قرب ميدان النافورة والمنطقة التجارية لتغطية جميع شوارع الهضبة العليا والوسطى بكفاءة.",
    coverage_note: "تغطية فورية داخل المقطم خلال 15 دقيقة."
  },
  {
    slug: "العاصمة-الإدارية",
    name_ar: "العاصمة الإدارية",
    landmarks: ["محور بن زايد", "الحي الحكومي", "الدائري الإقليمي"],
    adjacent_areas: ["طريق-السويس", "طريق-السخنة"],
    local_context: "توفير خدمات سحب آمنة لمرتادي العاصمة الإدارية ومحور بن زايد بعيداً عن الكثافات المفاجئة.",
    coverage_note: "وقت وصول يتراوح بين 20-30 دقيقة بحسب بوابات العاصمة."
  },
  {
    slug: "أكتوبر",
    name_ar: "أكتوبر",
    landmarks: ["ميدان الحصري", "محور 26 يوليو", "وصلة دهشور"],
    adjacent_areas: ["الشيخ-زايد"],
    local_context: "تعامل سريع مع اختناقات محور 26 يوليو وتغطية متواصلة لميدان الحصري ووصلة دهشور.",
    coverage_note: "أوناشنا في أكتوبر تضمن لك استجابة خلال 20 دقيقة."
  },
  {
    slug: "الشيخ-زايد",
    name_ar: "الشيخ زايد",
    landmarks: ["هايبر وان", "أركان بلازا", "محور النزهة"],
    adjacent_areas: ["أكتوبر"],
    local_context: "نخدم أهالي الشيخ زايد من خلال التمركز قرب هايبر وان وأركان بلازا للوصول السريع.",
    coverage_note: "متوسط وقت الوصول داخل الشيخ زايد هو 15 دقيقة."
  },
  {
    slug: "اسكندرية",
    name_ar: "اسكندرية",
    landmarks: ["طريق الكورنيش", "الطريق الزراعي", "محطة الرمل", "سموحة"],
    adjacent_areas: ["الساحل-الشمالي"],
    local_context: "خدمات شاملة لأعطال الطريق الزراعي وكورنيش الإسكندرية وسحب السيارات بكفاءة عالية في قلب المدينة.",
    coverage_note: "وقت الاستجابة يعتمد على الموقع المروري ويتراوح بين 20-30 دقيقة."
  },
  {
    slug: "الساحل-الشمالي",
    name_ar: "الساحل الشمالي",
    landmarks: ["طريق العلمين", "مارينا", "طريق الضبعة"],
    adjacent_areas: ["اسكندرية"],
    local_context: "نوفر دعم الطوارئ لمسافري طريق الساحل ومحور الضبعة وقرى الساحل لتأمين رحلاتهم.",
    coverage_note: "أوناشنا تتمركز لتغطية الطريق الساحلي في غضون 30-40 دقيقة."
  },
  {
    slug: "طريق-السخنة",
    name_ar: "طريق السخنة",
    landmarks: ["بوابات السخنة", "القطامية", "الكارته"],
    adjacent_areas: ["القطامية", "العاصمة-الإدارية"],
    local_context: "تمركز خاص عند الكارته وبوابات طريق العين السخنة للتعامل الفوري مع أعطال وحوادث الطرق السريعة.",
    coverage_note: "استجابة سريعة لسيارات طريق السخنة في غضون 20-25 دقيقة."
  },
  {
    slug: "طريق-السويس",
    name_ar: "طريق السويس",
    landmarks: ["بوابات السويس", "مدينتي", "الرحاب"],
    adjacent_areas: ["مدينتي", "العاصمة-الإدارية", "شيراتون"],
    local_context: "نغطي طريق السويس الحيوي من بدايته وحتى البوابات، مروراً بمداخل مدينتي والشروق.",
    coverage_note: "تغطية سريعة للطريق بمعدل استجابة 20 دقيقة."
  }
];
